import React, { useState } from 'react';
import { Grid, IconButton } from '@mui/material';
import FilterFronteiraComponent from './filtroFronteira';
import Legenda from '../legenda';
import MenuIcon from '@mui/icons-material/Menu';

const PainelFronteiras = ({ municipiosData, onFilterChange, onSelectMunicipio, legendData, selectedUF, currentColor }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const togglePanel = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Grid className="legenda" style={{ backgroundColor: 'rgba(83, 108, 149, 0.5)', padding: '1em', borderRadius: '8px', position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <p style={{ margin: '0.4em', textAlign: 'center' }}>Painel de controle</p>
                <IconButton onClick={togglePanel} style={{ color: 'white' }}>
                    <MenuIcon />
                </IconButton>
            </div>
            {isExpanded && (
                <>
                    <FilterFronteiraComponent
                        municipios={municipiosData.objects.municipios.geometries}
                        onChange={onFilterChange}
                        onSelectMunicipio={onSelectMunicipio}
                        selectedStates={['AM', 'AC', 'RR', 'RS', 'MT', 'AP', 'SC', 'RO', 'PR']}
                    />
                    <Legenda legendData={legendData} selectedUF={selectedUF} currentColor={currentColor} />
                </>
            )}
        </Grid>
    );
};

export default PainelFronteiras;
